import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cellKey"],
  _excluded2 = ["rowKey"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// stateful version of DynamicTable from @atlaskit
import React from 'react';
import PlatformDynamicTable from '@atlaskit/dynamic-table';
import { elementToForgeDoc } from '../../../utils/elementToForgeDoc';
import { DynamicTable as CodeGenDynamicTable } from './__generated__/index.partial';
/**
 * Non working props excluded:
 * isRankingDisabled
 * onPageRowsUpdate
 * onSort
 */

var renderCellForgeDoc = function renderCellForgeDoc(cells, render) {
  return cells.filter(function (cell) {
    return cell.type === 'Cell';
  }).map(function (cell) {
    var children = cell.children,
      cellProps = cell.props;
    var _ref = cellProps || {},
      cellKey = _ref.cellKey,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread(_objectSpread({}, restProps), {}, {
      key: cellKey,
      content: children.map(render).flat()
    });
  });
};
export var DynamicTable = function DynamicTable(props) {
  if (props.forgeDoc.children.length === 0) {
    return /*#__PURE__*/React.createElement(CodeGenDynamicTable, props);
  }
  var _ref2 = props.forgeDoc.props,
    caption = _ref2.caption,
    defaultPage = _ref2.defaultPage,
    defaultSortKey = _ref2.defaultSortKey,
    defaultSortOrder = _ref2.defaultSortOrder,
    emptyView = _ref2.emptyView,
    highlightedRowIndex = _ref2.highlightedRowIndex,
    isFixedSize = _ref2.isFixedSize,
    isLoading = _ref2.isLoading,
    isRankable = _ref2.isRankable,
    label = _ref2.label,
    loadingSpinnerSize = _ref2.loadingSpinnerSize,
    onRankEnd = _ref2.onRankEnd,
    onRankStart = _ref2.onRankStart,
    onSetPage = _ref2.onSetPage,
    page = _ref2.page,
    paginationi18n = _ref2.paginationi18n,
    rowsPerPage = _ref2.rowsPerPage,
    sortKey = _ref2.sortKey,
    sortOrder = _ref2.sortOrder,
    testId = _ref2.testId;
  var headForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props;
    return child.type === 'ContentWrapper' && ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.name) === 'head';
  });
  var head = headForgeDoc ? {
    cells: renderCellForgeDoc(headForgeDoc === null || headForgeDoc === void 0 ? void 0 : headForgeDoc.children, props.render)
  } : undefined;
  var rowsForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props2;
    return child.type === 'ContentWrapper' && ((_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.name) === 'rows';
  });
  var rows = rowsForgeDoc === null || rowsForgeDoc === void 0 ? void 0 : rowsForgeDoc.children.filter(function (row) {
    return row.type === 'Row';
  }).map(function (row) {
    var children = row.children,
      rowProps = row.props;
    var _ref3 = rowProps || {},
      rowKey = _ref3.rowKey,
      restProps = _objectWithoutProperties(_ref3, _excluded2);
    return _objectSpread(_objectSpread({}, restProps), {}, {
      key: rowKey,
      cells: renderCellForgeDoc(children, props.render)
    });
  });
  return /*#__PURE__*/React.createElement(PlatformDynamicTable, {
    caption: caption,
    defaultPage: defaultPage,
    defaultSortKey: defaultSortKey,
    defaultSortOrder: defaultSortOrder,
    emptyView: emptyView ? props.render(elementToForgeDoc(emptyView)) : undefined,
    head: head,
    highlightedRowIndex: highlightedRowIndex,
    isFixedSize: isFixedSize,
    isLoading: isLoading,
    isRankable: isRankable,
    label: label,
    loadingSpinnerSize: loadingSpinnerSize,
    onRankEnd: onRankEnd,
    onRankStart: onRankStart,
    onSetPage: onSetPage,
    page: page,
    paginationi18n: paginationi18n,
    rowsPerPage: rowsPerPage,
    rows: rows,
    sortKey: sortKey,
    sortOrder: sortOrder,
    testId: testId
  });
};